import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { useI18n } from "../../../i18n/I18nContext";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export default function Footer() {

  const [footerCategories, setFooterCategories] = useState([]);
  const { t } = useI18n();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/v1/categories`)
      .then((res) => {
        const cats = res.data.data || [];
        setFooterCategories(cats.slice(0, 7));
      })
      .catch(() => setFooterCategories([]));
  }, []);

  return (
    <footer className="bg-indigo-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-10 items-start">

          {/* Marca */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img alt="RacksForAll Logo" src="/racksforall.png" className="h-20 w-auto brightness-0 invert" />
              <p className="text-4xl font-bold text-white tracking-tight">RacksForAll</p>
            </div>
            <p className="text-base text-indigo-200/70 leading-relaxed max-w-xs mb-6">
              {t("Soluções profissionais de armazenamento para empresas em Portugal. Sistemas de estantes de qualidade projetados para fiabilidade e eficiência.")}
            </p>
            <div className="flex gap-3">
              {[
                { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61577909521947", icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /></svg> },

                { label: "Google Review", href: "https://g.page/r/Cb3sOg8iI4Z7EAE/review", icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5.01 14.99H12v-2h3.18c-.36.69-.9 1.29-1.56 1.74l1.41 1.41c.94-.7 1.63-1.67 2-2.79.13-.38.2-.79.2-1.2 0-.41-.07-.82-.2-1.2H12V11h5.01c.13.38.2.79.2 1.2 0 2.54-1.54 4.74-3.78 5.69L12 19.91V22l3.5-3.5c2.62-1.1 4.5-3.66 4.5-6.65 0-.58-.07-1.14-.2-1.67H12V8h5.64C16.43 5.61 14.38 4 12 4 8.13 4 5 7.13 5 11s3.13 7 7 7c3.53 0 6.47-2.61 6.94-6H17v-2h2.94c.04.32.06.66.06 1 0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c2.04 0 3.9.77 5.31 2.02L17.01 5.6A9.955 9.955 0 0 0 12 4C6.48 4 2 8.48 2 14h2c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8v2c5.52 0 10-4.48 10-10S17.52 2 12 2z" /></svg> },

                { label: "YouTube", href: "https://www.youtube.com/@racksforall20", icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg> },

                { label: "LinkedIn", href: "https://www.linkedin.com/company/racksforall", icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" /><circle cx="4" cy="4" r="2" /></svg> },

                { label: "Instagram", href: "https://instagram.com/racksforall.eu", icon: <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" /></svg> },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 text-indigo-200 hover:bg-indigo-600 hover:text-white transition-all duration-200"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Produtos */}
          <div className="pt-5">
            <p className="text-base font-bold text-white mb-5 uppercase tracking-widest">{t("Produtos")}</p>
            <ul className="space-y-3">
              {footerCategories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/products?category=${item.slug}`}
                    state={{ t: Date.now() }}
                    className="text-base text-indigo-200/70 hover:text-white transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Serviços */}
          <div className="pt-5">
            <p className="text-base font-bold text-white mb-5 uppercase tracking-widest">{t("Serviços")}</p>
            <ul className="space-y-3">
              {[
                { name: "Instalação", href: "/installation" },
                { name: "Consultoria", href: "/consulting" },
              ].map((n) => (
                <li key={n.name}>
                  <Link to={n.href} className="text-base text-indigo-200/70 hover:text-white transition-colors">
                    {t(n.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Empresa + Suporte */}
          <div className="space-y-8 pt-5">
            <div>
              <p className="text-base font-bold text-white mb-5 uppercase tracking-widest">{t("Empresa")}</p>
              <ul className="space-y-3">
                {[
                  { name: "Sobre Nós", href: "/about" },
                  { name: "A Nossa Equipa", href: "/our-team" },
                ].map((n) => (
                  <li key={n.name}>
                    <Link to={n.href} className="text-base text-indigo-200/70 hover:text-white transition-colors">{t(n.name)}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-base font-bold text-white mb-5 uppercase tracking-widest">{t("Suporte")}</p>
              <ul className="space-y-3">
                {[
                  { name: "Contactar Suporte", href: "/contact" },
                  { name: "Perguntas Frequentes", href: "/faq" },
                  { name: "Garantia", href: "/guarantee" },
                  { name: "Livro de Reclamações", href: "/complains" },
                ].map((n) => (
                  <li key={n.name}>
                    <Link to={n.href} className="text-base text-indigo-200/70 hover:text-white transition-colors">
                      {t(n.name)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-base text-indigo-200/50">© 2026 racksforall Portugal. {t("Todos os direitos reservados.")}</p>
          <div className="flex gap-6">
            <Link
              to="/privacy-policy"
              className="text-base text-indigo-200/50 transition-colors hover:text-white"
            >
              {t("Política de Privacidade")}
            </Link>
            <Link
              to="/returns-policy"
              className="text-base text-indigo-200/50 transition-colors hover:text-white"
            >
              {t("Política de Trocas e Devoluções")}
            </Link>
            <Link
              to="/customer-support"
              className="text-base text-indigo-200/50 transition-colors hover:text-white"
            >
              {t("Apoio ao Cliente")}
            </Link>

            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.Didomi?.preferences?.show();
              }}
            >
              {t("Consent choices")}
            </a>

          </div>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 text-indigo-200 hover:bg-indigo-600 hover:text-white transition-all">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
            </svg>
          </button>
        </div>
      </div>
    </footer>
  );
}
